// Advanced Mode 配置
// 用于启用高级模式（使用gemini-2.5-flash-ssvip模型）

export const ADVANCED_MODE_CONFIG = {
  // Advanced模式密码
  password: "demo2025",
  
  // 功能开关
  enabled: true,
  
  // UI显示文本
  displayName: "Advanced",
  tooltip: "⚡ 高级模式",
  
  // 密码提示文本
  passwordPrompt: "请输入Advanced模式密码",
  passwordError: "密码错误，请重试",
};

